import { RouterBuilder } from "./app/routes/routerBuilder/RouterBuilder";
import "./App.css";

const App = () => {
    return (
        <div className="App">
            <RouterBuilder />
        </div>
    );
};

export default App;
